import React from 'react';
import { Box, Paper, Typography, Container, Button } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { useAuth } from '../context/AuthContext';

const TeamlessWaiting = () => {
  const { user, logout } = useAuth();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: 'center',
          }}
        >
          <HourglassEmptyIcon
            sx={{
              fontSize: 64,
              color: 'primary.main',
              mb: 3,
            }}
          />
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
            Account Pending Approval
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Hello <strong>{user?.name}</strong>,
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your account has been successfully created, but you haven't been assigned to a team yet.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Please wait until the administrator reviews and approves your signup request. 
            You will be able to access the platform once you are added to a team.
          </Typography>
          <Box
            sx={{
              mt: 4,
              pt: 3,
              borderTop: 1,
              borderColor: 'divider',
            }}
          >
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              If you have any questions, please contact your administrator.
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              onClick={logout}
              sx={{ mt: 2 }}
            >
              Logout
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default TeamlessWaiting;

